import React from 'react'
import './Home.scss'
import WelcomeSection from './sections/WelcomeSection';
import AboutUsSection from './sections/AboutUsSection';
import OurServiceSection from './sections/OurServiceSection';
import Expirience from './sections/Expirience';
import PartnersSection from './sections/PartnersSection';
import TradingMarketsSection from './sections/TradingMarketsSection';
import ContactsSection from './sections/ContactsSection';
import CommodityBrokerage from './sections/CommodityBrokerage';


const Home = () => {
  return (
    <div className='home'>
      <WelcomeSection/>
      <CommodityBrokerage/>
      {/* <OurServiceSection/> */}
      <PartnersSection/>
      {/* <TradingMarketsSection/> */}
      {/* <Expirience/> */}
      <AboutUsSection/>
      <ContactsSection/>
    </div>
  )
}

export default Home
